<div [id]="divId" class="track-item">
    <svg width="90px" height="72px">
        <g class="map"></g>
    </svg>
    <div [ngClass]="fill !== 'none' ? 'track-name-selected': ''" *ngIf="name.length > 0" class="track-name">
        <span title="{{name}}">{{name}}</span>
    </div>
    <div class="track-bg"></div>
</div>